import { useState } from "react";
import { refreshAccessToken, logoutUserDevice } from "../apis";
import { commonStrings } from "../components/StringBundle";
import { LOGOUT_REASON_KEY, LAST_ACTIVITY_KEY } from "../constants/autoLogout";
const CryptoJS = require("crypto-js");
const key = CryptoJS.enc.Utf8.parse("example key 1234");
const useToken = () => {
  const [token, setToken] = useState(localStorage.getItem("currentUserId"));
  const [role, setRole] = useState(localStorage.getItem("currentUserRole"));
  const [company, setCompany] = useState(localStorage.getItem("company") || 'ccl');
  const updateCompany = (newCompany) => {
    localStorage.setItem("company", newCompany);
    setCompany(newCompany);
  }

  // details.id/refreshtoken/secret_code no longer exist — VerifyTOTP hands
  // the real session tokens over as HttpOnly cookies, invisible to JS, and
  // the JSON body only carries plain identity fields. user_id doubles as
  // the "is logged in" marker other code (e.g. AppBar's idle-logout check)
  // reads from the "currentUserId" key. secretCode state/return and
  // AuthContext's secretCode field were removed for the same reason —
  // nothing ever writes "currentUserSecretCode" anymore.
  const storeToken = (details) => {
    localStorage.setItem("currentUserId", details.user_id);
    localStorage.setItem("currentUserRole", details.role);
    localStorage.setItem("currentUserName", details.user_name);
    localStorage.setItem("currentUserFirstName", details.first_name ?? "");
    localStorage.setItem("currentUserLastName", details.last_name ?? "");
    localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString()); // fresh session — an old value left by a manual logout must not read as stale in index.js
    setRole(details.role);
    setToken(details.user_id);
  };
  const getToken = () => {
    let value = localStorage.getItem("currentUserId");
    return value;
  };
  // name stays the login username (unchanged — many callers use it as an audit/"created by"
  // identifier, not a display name). firstName/lastName are separate, additive fields for
  // display-only greetings (e.g. the home page welcome banner).
  const getCurrentUserDetails = () => {
    return {
      id: localStorage.getItem("currentUserId"),
      role: localStorage.getItem("currentUserRole"),
      name: localStorage.getItem("currentUserName"),
      firstName: localStorage.getItem("currentUserFirstName"),
      lastName: localStorage.getItem("currentUserLastName"),
    };
  };
  const setPreference = (details) => {
    localStorage.setItem("preferenceLogin", JSON.stringify(details));
    // localStorage.setItem("preference", JSON.stringify(details));
  };
  const getPreference = () => {
    let value = localStorage.getItem("preference");
    const preference = JSON.parse(value);
    if (preference) {
      preference.name = decryptCredential(preference.name);
    }
    return preference;
  };

  // Matches utils/crypto.ts's encryptInfo: a random 16-byte IV prepended to
  // the ciphertext, base64-encoded as one blob.
  const decryptCredential = (str) => {
    const raw = CryptoJS.enc.Base64.parse(str.toString());
    const iv = CryptoJS.lib.WordArray.create(raw.words.slice(0, 4), 16);
    const ciphertext = CryptoJS.lib.WordArray.create(raw.words.slice(4), raw.sigBytes - 16);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, { iv, padding: CryptoJS.pad.Pkcs7 });
    return decrypted.toString(CryptoJS.enc.Utf8);
  };



  // Ends only this browser's session via Cognito RevokeToken — other devices stay logged in.
  const removeToken = async (reason = 'manual') => {
    localStorage.setItem(LOGOUT_REASON_KEY, reason); // written before removeItem below fires the storage event other tabs read
    try {
      await logoutUserDevice();
    } catch (err) {
      console.log(commonStrings.logoutRequestFailed, err);
    }
    localStorage.removeItem("currentUserId");
    localStorage.removeItem("currentUserName");
    localStorage.removeItem("currentUserFirstName");
    localStorage.removeItem("currentUserLastName");
    localStorage.removeItem("preference");
    localStorage.removeItem("currentActivePage");
    localStorage.removeItem("currentUserRole");
    localStorage.removeItem("sidebarCollapsed");
    setToken(null);
    setRole(undefined);
  };

  // Silently extends the session by exchanging the refresh_token cookie for
  // a fresh access_token cookie — no credentials to replay, no response
  // body to store (identity doesn't change on a refresh).
  const refreshToken = async () => {
    if (!token) return;
    try {
      await refreshAccessToken();
    } catch (err) {
      console.log(commonStrings.tokenRefreshFailed, err);
    }
  };
  return {
    storeToken,
    getToken,
    setPreference,
    getPreference,
    getCurrentUserDetails,
    token,
    role,
    company,
    removeToken,
    refreshToken,
    updateCompany,
  };
};

export default useToken;
